import React, { useEffect } from 'react';
import Chart from 'react-apexcharts';

import { dominioDemandaCirurgica } from '../../../../config/database';

export default function ModalProcedimentosRealizadosPorEquipe(props) {
  const [options, setOptions] = React.useState({
    series: [],
    labels: [],
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      position: 'right',
      horizontalAlign: 'left',
    },
    responsive: [
      {
        breakpoint: 450,
        options: {
          chart: {
            height: '350px',
            width: '350px',
          },
          legend: {
            show: true,
            showForSingleSeries: false,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: 'bottom',
            horizontalAlign: 'left',
            floating: false,
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial',
            fontWeight: 400,
            formatter: undefined,
            inverseOrder: false,
            width: 300,
            height: undefined,
            tooltipHoverFormatter: undefined,
            customLegendItems: [],
            offsetX: 0,
            offsetY: 0,
            labels: {
              colors: undefined,
              useSeriesColors: false,
            },
            itemMargin: {
              horizontal: 8,
              vertical: 2,
            },
            onItemClick: {
              toggleDataSeries: true,
            },
            onItemHover: {
              highlightDataSeries: true,
            },
          },
        },
      },

      {
        breakpoint: 576,
        options: {
          chart: {
            height: '450px',
            width: '450px',
          },
          legend: {
            position: 'bottom',
            width: 400,
          },
        },
      },

      {
        breakpoint: 768,
        options: {
          chart: {
            height: '500px',
            width: '500px',
          },
          legend: {
            position: 'bottom',
            width: 400,
          },
        },
      },

      {
        breakpoint: 992,
        options: {
          chart: {
            height: '600px',
            width: '600px',
          },
        },
      },

      {
        breakpoint: 1930,
        options: {
          chart: {
            height: '900px',
            width: '900px',
          },
        },
      },
    ],
  });
  const { equipes, centrosCirurgicos, dataInicio, dataFim, eOnco } = props;
  /* const [equipesSelecionadasModal, setEquipesSelecionadasModal] = React.useState(
    equipesSelecionadas
  ); */
  /* const [equipes, setEquipes] = React.useState([]); */

  /* const handleCarregaGrafico = () => {
    if (equipesSelecionadas) {
      if (equipesSelecionadas.length > 0)
        return <Chart options={options} series={options.series} type="pie" />;
    }
    return (
      <div style={{ width: '57vw', textAlign: 'center' }}>
        <h3>Selecione uma equipe para carregar esse gráfico</h3>
      </div>
    );
  }; */

  /* const carregaEquipes = () => {
    dominioDemandaCirurgica.get('/api/equipesAtivas').then(response => {
      setEquipes(response.data);
    });
  }; */

  /* useEffect(() => {
    if (equipesSelecionadas) if (equipesSelecionadas.length > 0) updateCharts();
  }, [equipesSelecionadas]); */

  /* useEffect(() => {
    carregaEquipes();
  }, []); */

  const updateCharts = () => {
    const idsEquipes = equipes.map(equipe => {
      return equipe.id;
    });

    const idsCentrosCirurgicos = centrosCirurgicos.map(centroCirurgico => {
      return centroCirurgico.id;
    });

    const dados = {
      filtros: {
        equipes: idsEquipes?.length > 0 ? idsEquipes.join() : null,
        centrosCirurgicos: idsCentrosCirurgicos?.length > 0 ? idsCentrosCirurgicos.join() : null,
        dataInicio: new Date(dataInicio),
        dataFim: new Date(dataFim),
        eOnco,
      },
    };

    dominioDemandaCirurgica
      .post(`/api/listarProcedimentosRealizadosPorEquipe`, dados)
      .then(response => {
        const config = {
          series: [],
          labels: [],
          dataLabels: {
            enabled: true,
          },
          legend: {},
        };
        const series = response.data.map(dado => {
          return dado.quantidade_procedimento;
        });
        const labels = response.data.map(dado => {
          return dado.procedimento.substring(0, 50);
        });
        config.series = series;
        config.labels = labels;
        setOptions(config);
      });
  };

  useEffect(() => {
    updateCharts();
  }, [equipes]);

  return (
    /* <Autocomplete
        multiple
        size="small"
        style={{ width: 500 }}
        id="tags-standard"
        options={equipes}
        getOptionLabel={option => option.descricao}
        onChange={(e, values) => {
          setEquipesSelecionadasModal(values);
        }}
        renderInput={params => (
          <TextField
            {...params}
            variant="standard"
            label="Equipes"
            style={{ backgroundColor: 'white' }}
            placeholder="Selecione uma ou mais equipes"
          />
        )}
      /> */

    <>
      {equipes.length === 0 ? (
        <div className="center" style={{ height: '400px' }}>
          <h3>Selecione uma equipe para carregar esse gráfico</h3>
        </div>
      ) : (
        <Chart options={options} series={options.series} type="pie" />
      )}
    </>
  );
}
